<template>
  <div class="container text-center py-5 my-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <h1 class="display-1 fw-bold text-danger">404</h1>
        <h2 class="mb-4">Strona nie została znaleziona</h2>
        <p class="lead mb-4">
          Przepraszamy, ale strona, której szukasz, nie istnieje lub została przeniesiona.
        </p>
        <router-link to="/" class="btn btn-primary btn-lg">
          Powrót do strony głównej
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFoundPage'
}
</script>

<style scoped>
h1 {
  font-size: 6rem;
}
</style>